import { render } from "./FinancialWelfare.vue?vue&type=template&id=37062638&scoped=true&ts=true"
import script from "./FinancialWelfare.vue?vue&type=script&lang=ts"
export * from "./FinancialWelfare.vue?vue&type=script&lang=ts"

import "./FinancialWelfare.vue?vue&type=style&index=0&id=37062638&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37062638"]])

export default __exports__